var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibilityPassHidden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.595,
    height: 16.458,
    viewBox: "0 0 18.595 16.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M14.846,17.989a10,10,0,0,1-1.63.133,8.655,8.655,0,0,1-8.3-5.3,7.289,7.289,0,0,1,1.357-2.3m5.1.689a2.788,2.788,0,0,1,1.843-.667,2.46,2.46,0,0,1,2.609,2.273,2.118,2.118,0,0,1-.765,1.606m-3.687-3.212,3.687,3.212m-3.687-3.212L8.511,8.72m6.548,5.7,2.861,2.492M5.39,6,8.511,8.72m0,0a9.6,9.6,0,0,1,4.7-1.2,8.656,8.656,0,0,1,8.3,5.3,7.824,7.824,0,0,1-3.6,4.1m0,0,3.122,2.72",
    transform: "translate(-4.2 -2.589)",
    fill: "none",
    stroke: "#088168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityPassHidden);
export default __webpack_public_path__ + "static/media/visibilityPassHidden.c4bf00404fe96ce5baf96f83d14eb8d3.svg";
export { ForwardRef as ReactComponent };